<div>
  <mat-form-field class="w-100" appearance="outline">
    <mat-label>Trefwoorden</mat-label>
    <mat-chip-grid
      #chipGrid
      aria-label="Enter tags"
    >
      @for (tag of selectedItemList; track tag.id) {
        <mat-chip-row
          [removable]="true"
          (edited)="editedMatChipRow($event, tag)"
          (removed)="removeChip(tag)"
        >
          {{ tag.name }}
          <button
            matChipRemove
            [attr.aria-label]="'Remove tag ' + tag.name"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      #tagInput
      [placeholder]="selectedItemList.length ? '' : 'Zoek bestaand trefwoord of voer nieuw trefwoord in...'"
      [formControl]="inputFormControl"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [matChipInputAddOnBlur]="false"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="inputTokenEnd($event)"
      (blur)="clearChipInput()"
    />

    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="optionSelected($event)"
    >
      @for (tag of resultFromService$ | async; track tag.id) {
        <mat-option [value]="tag">{{ tag.name }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
